
const ONE_KILOBYTE = 1024;
const ONE_POINT_FIVE_KILOBYTES = ONE_KILOBYTE * 1.5;

const unacceptableFileExtensionsInUpperCase = [
    // DUPLICATED IN: GenericUploadFile.java
    // List from https://www.lifewire.com/list-of-executable-file-extensions-2626061
    "ACTION", // Automator Action macOS
    "APK", // Application Android
    "APP", // Executable macOS
    "BAT", // Batch File Windows
    "BIN", // Binary Executable Windows , macOS, Linux
    "CMD", // Command Script Windows
    "COM", // Command File Windows
    "COMMAND", // Terminal Command macOS
    "CPL", // Control Panel Extension Windows
    "CSH", // C Shell Script macOS, Linux
    "DLL", // Shared Library File, Windows
    "DL_", // Shared Library File, Windows
    "EXE", // Executable Windows
    "EX_", // Executable Windows
    "GADGET", // Windows Gadget Windows
    "INF", // Setup Information File Windows
    "INS", // Internet Communication Settings Windows
    "INX", // InstallShield Compiled Script Windows
    "IPA", // Application iOS
    "ISU", // InstallShield Uninstaller Script Windows
    "JOB", // Windows Task Scheduler Job File Windows
    "JSE", // JScript Encoded File Windows
    "KSH", // Unix Korn Shell Script Linux
    "LNK", // File Shortcut Windows
    "MSC", // Microsoft Common Console Document Windows
    "MSI", // Windows Installer Package Windows
    "MSP", // Windows Installer Patch Windows
    "MST", // Windows Installer Setup Transform File Windows
    "OSX", // Executable macOS
    "OUT", // Executable Linux
    "PAF", // Portable Application Installer File Windows
    "PIF", // Program Information File Windows
    "PRG", // Executable GEM
    "PS1", // Windows PowerShell Cmdlet Windows
    "REG", // Registry Data File Windows
    "RGS", // Registry Script Windows
    "RUN", // Executable Linux
    "SCR", // Screensaver Executable Windows
    "SCT", // Windows Scriptlet Windows
    "SHB", // Windows Document Shortcut Windows
    "SHS", // Shell Scrap Object Windows
    "U3P", // U3 Smart Application Windows
    "VB", // VBScript File Windows
    "VBE", // VBScript Encoded Script Windows
    "VBS", // VBScript File Windows
    "VBSCRIPT", // Visual Basic Script Windows
    "WORKFLOW", // Automator Workflow macOS
    "WS", // Windows Script Windows
    "WSF", // Windows Script Windows
    "WSH", // Windows Script Preference Windows
    // Additional extensions from https://www.howtogeek.com/137270/50-file-extensions-that-are-potentially-dangerous-on-windows/
    "SH", // Unix shell scripts  Linux, macOS
    "SCF", // Windows Explorer command file  Windows
    "APPLICATION", // Windows Click-Once application  Windows
    "HTA", // An HTML application. Unlike HTML applications run in browsers, .HTA files are run as trusted applications without sandboxing.
    "JAR", // JAR files contain executable Java code. If you have the Java runtime installed, .JAR files will be run as programs.
    "JS", // A JavaScript file. .JS files are normally used by webpages and are safe if run in Web browsers. However, Windows will run .JS files outside the browser with no sandboxing.
    "JSE", // An encrypted JavaScript file.
    "WSC", // Windows Script Component control files. Used along with with Windows Script files
    "PS1XML", "PS2", "PS2XML", "PSC1", "PSC2", // A Windows PowerShell script. Runs PowerShell commands in the order specified in the file.
    "MSH", "MSH1", "MSH2", "MSHXML", "MSH1XML", "MSH2XML" // A Monad script file. Monad was later renamed PowerShell.
];

const onlineFileListFileExtensionsInUpperCase = [
    "GSHEET", // Google Sheets
    "GDOC", // Google Docs
    "GSLIDES", // Google Slides
    "GFORM", // Google Forms
    "GDRAW", // Google Draw
    "GTABLE" // Google Fusion Table
];

export class FileUtils {

    static validateFileExtension(fileName) {
        return FileUtils.#validateFileExtensionAgainstList(fileName, unacceptableFileExtensionsInUpperCase);
    }

    static ensureNotOnlineFileExtension(fileName) {
        return FileUtils.#validateFileExtensionAgainstList(fileName, onlineFileListFileExtensionsInUpperCase);
    }

    static #validateFileExtensionAgainstList(fileName, listOfExtensions) {
        if (!fileName) {
            // empty file name, doesn't make sense, so fail
            return false;
        }
        const extIndex = fileName.lastIndexOf('.');
        if (extIndex < 0) {
            // No extension, this is okay
            return true;
        }
        let fileExt = fileName.substring(extIndex + 1);
        if (!fileExt) {
            // empty extension, this is okay
            return true;
        }
        fileExt = fileExt.toUpperCase();
        let i = listOfExtensions.length;
        while (i--) {
            if (listOfExtensions[i] === fileExt) {
                return false;
            }
        }
        return true;
    }

    static formatFileSize(size) {
        if (size < ONE_POINT_FIVE_KILOBYTES) {
            return String(size) + " B";
        } else if (size < ONE_POINT_FIVE_KILOBYTES * ONE_KILOBYTE) {
            return (size / ONE_KILOBYTE).toFixed(1) + " kB";
        } else if (size < ONE_POINT_FIVE_KILOBYTES * ONE_KILOBYTE * ONE_KILOBYTE) {
            return (size / (ONE_KILOBYTE * ONE_KILOBYTE)).toFixed(1) + " MB";
        } else {
            return (size / (ONE_KILOBYTE * ONE_KILOBYTE * ONE_KILOBYTE)).toFixed(1) + " TB";
        }
    }
}
